export default __webpack_public_path__ + "static/media/Desert tree.7db1e8fb.png";